<template>
  <div>
    <ul
      id="main-navigation"
      class="grid tablet:grid-cols-2 tablet:gap-4 desktop:grid-cols-3 desktop:gap-6"
    >
      <MenuLinksItem
        v-for="link in mapped"
        :key="link.id"
        v-bind="link"
        v-model="activeTree"
      />
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { MenuLinkTreeFirstFragment } from '#graphql-operations'
import { notNullish } from '@vueuse/core'
import { mapTreeItem, type MappedLink } from '../helper'
import MenuLinksItem from './Item.vue'

const props = defineProps<{
  links: MenuLinkTreeFirstFragment[]
}>()

const activeTree = ref('')

const mapped = computed<MappedLink[]>(() =>
  props.links.map(mapTreeItem).filter(notNullish),
)
</script>
